<template>
  <div class="teams">
    <div class="teams__top-wrapper">
      <div class="image-wrapper">
        <img
            alt="trophy"
            class="teams-card__image"
            src="/img/trophy-teams.png"
        />
      </div>
      <div class="teams__info">
        <h1 class="teams__info-title">
          {{ t('teams_label') }}
        </h1>
        <p class="teams__info-desc">
          {{
            currW <= 525 && !toggle ?
                t('teams_desc').slice(0, 115) + '...' :
                t('teams_desc')
          }}
          <button class="white btn btn-link" @click="toggle = !toggle">
            {{ toggle ? t('show_less') : t('show_more') }}
          </button>
        </p>
      </div>
    </div>

    <div class="teams__sort f">
      <span class="f14 light">
        {{ props.data.total_count }} {{ t('teams').toLowerCase() }}
      </span>

      <ui-input
          v-model.trim="search"
          :placeholder="(currW <= 525 ? t('search_among_teams', {count: props.data.total_count}) : t('search')) + '...'"
          showSearchIcon
      />
    </div>

    <template v-if="props.data?.result?.length && !loading">
      <div class="teams__grid">
        <TeamCard
            v-for="item in (props.data.result || []) as ProTeam[]"
            :key="item.id"
            :item="item"
        />
      </div>

      <paginate-v3
          v-if="props.data?.result?.length && !loading"
          :pages-length="props.data.max_pages"
          :total="props.data.total_count"
          :total-items="18 * page > props.data.total_count ? props.data.total_count : 18 * page"
          use-query
      />
    </template>

    <div v-else-if="loading" class="load_period loading-container my54 py54">
      <div class="f fc">
        <i class="i-loading ml10"></i>
      </div>
    </div>
    <div v-else>
      <ui-no-result class="mxa" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {PaginatedProTeams, ProTeam} from "~/graphql/generated/schema-types";
import TeamCard from "~/components/Pages/Teams/Components/TeamCard.vue";

const props = defineProps<{
  data: PaginatedProTeams
  loading: boolean
}>()
const route = useRoute()
const currW = useResize()

const search = defineModel('search')
const page = computed(() =>
    route.query.page ? parseInt(route.query.page as string) : 1)

const {t} = useI18n()

const toggle = ref(false)
</script>

<style lang="scss" scoped>
.teams {
  padding-top: 32px;
  padding-bottom: 80px;

  &__top-wrapper {
    display: flex;
    align-items: center;
    gap: 56px;
    margin-bottom: 40px;

    .image-wrapper {
      width: 200px;
      height: 200px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        position: relative;
        z-index: 1;
      }

      //&:after {
      //  content: '\e81f';
      //  font-family: 'fontello';
      //  position: absolute;
      //  inset: 0;
      //  text-align: center;
      //  display: block;
      //  font-size: 15rem;
      //  line-height: 20rem;
      //  color: var(--surfaces-outline);
      //  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
      //  opacity: 0.2;
      //}
    }
  }

  &__sort {
    margin-bottom: 16px;

    &:deep(.form_field) {
      width: max-content;
      min-width: 192px;
    }
  }

  &__info {
    &-title {
      font-size: 28px;
      font-weight: 600;
      line-height: 36px;
      margin-bottom: 20px;
      color: var(--surfaces-on-surface);
    }

    &-desc {
      max-width: 541px;
      font-size: 16px;
      font-weight: 400;
      line-height: 32px;
      color: var(--surfaces-on-surface-variable);

      .btn-link {
        display: none;
        font-size: 16px;
        text-decoration: underline;
        color: var(--surfaces-on-surface);
        padding: 0 0 0 4px;
        position: relative;
        bottom: 2px;
      }
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    gap: 16px;
  }

  @media (max-width: 525px) {
    padding-bottom: 16px;
    &__top-wrapper {
      flex-direction: column;
      gap: 8px;
      margin-bottom: 24px;

      .image-wrapper {
        width: 230px;
        height: 230px;
      }
    }

    &__sort {
      .light {
        display: none;
      }

      &:deep(.form_field) {
        width: 100%;
      }
    }

    &__info {
      &-title {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 12px;
      }

      &-desc {
        font-size: 14px;
        font-weight: 400;
        line-height: 28px;

        .btn-link {
          display: inline-block;
          font-size: 14px;
        }
      }
    }

    &__grid {
      gap: 12px;
      grid-template-columns: repeat(auto-fill, minmax(138px, 1fr));
    }
  }
}
</style>
